import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
	selector: 'app-file-drop',
	templateUrl: './file-drop.component.html',
	styleUrls: ['./file-drop.component.css']
})
export class FileDropComponent implements OnInit {

	public loading: boolean = false;
	public file: any = null; 

	@Input() shortLink!: string;

	@Output() childEvent = new EventEmitter();

	constructor(
		private apiService: UserApiService
		, private logger: LoggerService
	) {

	}

	ngOnInit(): void {
	}

	onUpload(uploadEvent) {
		try {
			this.loading = true;

			var apirequest = new ApiRequestModel(`File`);

			const file: File = uploadEvent.target.files[0];
			this.apiService.uploadFile(apirequest, file)
				.subscribe(
					result => {
						if (result.succeeded) {
							this.shortLink='http://192.168.0.17:4700/'+result.data;
							console.log(result);
							console.log(this.shortLink);
						}else{
							for (let index = 0; index < result.errorMessages.length; index++) {
								const element = result.errorMessages[index];
								this.logger.addError(element,false);
							}
						}
						this.loading = false;
					},
					error => {
						if (error.status == 200 && error.error.text) {
							this.shortLink = this.apiService.generateFileUrl(error.error.text);
							this.childEvent.emit(this.shortLink);
						} else {
							this.logger.addError(error,true);
						}
						this.loading = false;
					},
					() => {
						console.log(`Completed!`);
					}
				);
		} catch (error) {
			this.logger.addException(error,true);
		}
	}

	public remove() {
		this.shortLink = "";
	}
}
